var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"formtitle"},[_vm._v("绑定企业")]),_c('div',{staticClass:"companybox"},[_c('h2',[_vm._v(_vm._s(_vm.qymc))]),_c('p',[_vm._v("税号："+_vm._s(_vm.qysh))])]),_c('div',{staticClass:"unbindingbtn",on:{"click":_vm.unbinding}},[_vm._v("解绑")])])
}
var staticRenderFns = []

export { render, staticRenderFns }